/*eslint-disable*/
import React, { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { useHistory } from "react-router-dom";
import axios from "axios";

import classNames from "classnames";
import Parallax from "components/Parallax/Parallax.js";
import { makeStyles } from "@material-ui/core/styles";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
// import Slide from "@material-ui/core/Slide";
import Tooltip from "@material-ui/core/Tooltip";
import Close from "@material-ui/icons/Close";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import Table from "components/Table/Table.js";
import SweetAlert from "react-bootstrap-sweetalert";
import profilePageStyle from "assets/jss/material-kit-pro-react/views/profilePageStyle.js";
import InshaHeader from "views/InshaBanglesPage/Section/InshaHeader";
import InshaHeaderLink from "views/InshaBanglesPage/Section/InshaHeaderLink";
import Footer from "views/InshaBanglesPage/Section/InshaFooter";

import invoiceStyle from "assets/jss/material-kit-pro-react/views/invoiceTableStyle";
import listCart from "assets/jss/material-kit-pro-react/views/shoppingCartStyle.js";
import style from "assets/jss/material-kit-pro-react/components/buttonStyle.js";
import { localApi, credentials, roundUp } from "utils/headApi";

const useStyles = makeStyles(profilePageStyle);
const useStylesTable = makeStyles(invoiceStyle);
const useStyleCart = makeStyles(listCart);
const useStyleAlert = makeStyles(style);

export default function AddCart({ ...rest }) {
  const [addCart, setAddCart] = React.useState([]);
  const [userId, setUserId] = React.useState("");
  const [submitted, setSubmitted] = React.useState(false);
  const [submitteds, setSubmitteds] = React.useState(false);
  const [submittedConfirm, setSubmittedConfirm] = React.useState(false);
  const [cardId, setCartId] = React.useState();
  const [load, setLoad] = React.useState(false);
  const [cartShort, setCartShort] = React.useState("");

  const [allSameGstCash, setAllSameGstCash] = React.useState(false);

  const classes = useStyles();
  const history = useHistory();

  const classesTable = useStylesTable();
  const classeCart = useStyleCart();
  const classeAlert = useStyleAlert();

  const activeSession = sessionStorage.getItem("sessionData");
  const userObj = JSON.parse(sessionStorage.getItem("sessionData"));

  const date = Intl.DateTimeFormat("fr-CA", {
    year: "numeric",
    month: "numeric",
    day: "numeric",
  })
    .format(new Date())
    .replaceAll("/", "-");

  const current = new Date();
  const dateCurrent = `${current.getDate()}-${current.getMonth() + 1
    }-${current.getFullYear()}`;
  current.setDate(current.getDate() + 10);
  let dateEx = new Date(current).toLocaleDateString("de");

  useEffect(() => {
    const fetchCartListData = async () => {
      try {
        const response = await fetch(localApi + `/clientGroup/allList`, {
          method: "GET",
          headers: {
            Authorization: `Basic ${credentials}`,
          },
        });
        const json = await response.json();
        const cList = json.ClientList.filter((f) => f.regId === userObj.id)[0];

        const list =
          localApi +
          `/cart/expireCart/byAdminAndClientIdAndAcitve/${userObj.admin.id}/${cList.id}?active=0`;
        const result = await fetch(list, {
          method: "GET",
          
          headers: {
            Authorization: `Basic ${credentials}`,
          },

        });
        const data = await result.json();
        // console.log(data);
        // setAddCart(data);
        if (data.error === "true") {
          setLoad(false);
          history.push("/error-page");
        } else {
          setLoad(true);
          const cLength = data.length === 1 ? data : "";
          if (cLength) {
            // console.log(cLength[0]);
            setCartShort(cLength[0]);
            setAddCart(data && data.length != 0 ? data : "");

            const isAllSame = data.every(
              (item) => item.gstCash === data[0].gstCash
            );
            // console.log(isAllSame);
            setAllSameGstCash(isAllSame);
          } else {
            setAddCart(
              data && data.length != 0 ? data : history.push("/error-page")
            );

            const isAllSame = data.every(
              (item) => item.gstCash === data[0].gstCash
            );
            // console.log(isAllSame);
            setAllSameGstCash(isAllSame);
          }
        }
      } catch (error) {
        console.log("error", error);
      }
    };

    fetchCartListData();
  }, []);

  const handleitemRemove = (c, submitted) => {
    setSubmitted(true);
  };

  // const handleConfirm = () => {
  //   // console.log(cardId);
  //   axios
  //     .delete(
  //       localApi +
  //       `/cart/delete/byAdminAndCartId/${userObj.admin.id}/${cardId.id}`,
  //       {
  //         headers: {
  //           Authorization: `Basic ${credentials}`,
  //         },
  //         
  //       }
  //     )
  //     .then((res) => {
  //       if (cartShort) {
  //         history.push(
  //           `/bangles-size-mm-list?catdesc=${cartShort && cartShort.cartCategory.title
  //           }&cat1desc=${cartShort && cartShort.cartParent.title
  //           }&Plating=Gold%20Plating`
  //         );
  //       }
  //     });
  //   setSubmittedConfirm(true);
  // };

  const handleConfirm = () => {
    fetch(
      `${localApi}/cart/delete/byAdminAndCartId/${userObj.admin.id}/${cardId.id}`,
      {
        method: "DELETE",
         // ✅ important for cookies/session
        headers: {
          "Authorization": `Basic ${credentials}`,
        },

      }
    )
      .then((response) => {
        if (!response.ok) {
          throw new Error("Failed to delete cart item");
        }
        return response.json();
      })
      .then((res) => {
        if (cartShort) {
          history.push(
            `/bangles-size-mm-list?catdesc=${cartShort?.cartCategory?.title}&cat1desc=${cartShort?.cartParent?.title}&Plating=Gold%20Plating`
          );
        }
      })
      .catch((error) => {
        console.error("❌ Delete failed:", error);
      });

    setSubmittedConfirm(true);
  };


  const hideAlert = () => {
    setSubmitted(false);
    setSubmittedConfirm(false);
    window.location.reload(false);
  };

  var totalCal = 0;
  var totalCalMix = 0;
  var totalSum = 0;

  return (
    <div>
      <Helmet>
        <title>My Cart</title>
      </Helmet>
      {load ? (
        <>
          <InshaHeader
            brand="Home"
            links={<InshaHeaderLink dropdownHoverColor="dark" />}
            fixed
            color="transparent"
            changeColorOnScroll={{
              height: 100,
              color: "dark",
            }}
          />
          <Parallax
            image={require("assets/img/bg6.jpg").default}
            filter="dark"
            className={classes.parallax}
          ></Parallax>
          <div className={classNames(classeCart.main, classeCart.mainRaised)}>
            <div className={classeCart.container}>
              {submitteds ? (
                <SweetAlert
                  type={alertType}
                  style={{ display: "block", marginTop: "-100px" }}
                  title={alertMsg}
                  onConfirm={() => hideAlert()}
                  confirmBtnCssClass={
                    classeAlert.button + " " + classeAlert.success
                  }
                />
              ) : null}
              {submitted ? (
                <SweetAlert
                  warning
                  style={{ display: "block", marginTop: "100px" }}
                  title="Are you sure?"
                  onConfirm={handleConfirm}
                  onCancel={() => hideAlert()}
                  confirmBtnCssClass={
                    classeAlert.button + " " + classeAlert.success
                  }
                  cancelBtnCssClass={
                    classeAlert.button + " " + classeAlert.danger
                  }
                  confirmBtnText="Yes, delete it!"
                  cancelBtnText="Cancel"
                  showCancel
                >
                  That you want to remove this item from your cart?
                </SweetAlert>
              ) : null}

              {submittedConfirm ? (
                <SweetAlert
                  success
                  style={{ display: "block", marginTop: "100px" }}
                  title="Deleted!"
                  onConfirm={() => hideAlert()}
                  onCancel={() => hideAlert()}
                  confirmBtnCssClass={
                    classeAlert.button + " " + classeAlert.success
                  }
                >
                  Your item has been deleted.
                </SweetAlert>
              ) : null}
              <Card plain>
                <CardBody plain>
                  <h3 className={classeCart.cardTitle}>My Cart</h3>
                  <Table
                    tableHead={[
                      <span className={classesTable.tableHead} key="sr">
                        Sr.
                        <br />
                        No.
                      </span>,
                      "",
                      <span className={classesTable.tableHead} key="des">
                        Description of Goods
                      </span>,
                      <span
                        className={
                          classesTable.tableHead + " " + classesTable.headRight
                        }
                        key="ctn"
                      >
                        Carton
                      </span>,
                      <span
                        className={
                          classesTable.tableHead + " " + classesTable.headRight
                        }
                        key="qty"
                      >
                        Quantity
                      </span>,
                      <span
                        className={
                          classesTable.tableHead + " " + classesTable.headRight
                        }
                        key="pri"
                      >
                        Price
                      </span>,
                      <span
                        className={
                          classesTable.tableHead + " " + classesTable.headRight
                        }
                        key="amt"
                      >
                        Amount
                      </span>,
                      "",
                    ]}
                    tableData={[
                      ...addCart.map((c, index) => [
                        <span className={classesTable.listNumber} key={c.id}>
                          {index + 1}
                        </span>,
                        <div className={classeCart.imgContainer} key={c.id}>
                          {/* Date: {c.createDate.slice(0, -19)} */}
                          {"P" + c.pId + "/C" + c.id}
                          <img
                            src={c.cartImage[0].cpanelPath}
                            className={classes.img}
                            style={{ height: "140px" }}
                          />
                        </div>,
                        <span key={c.id}>
                          <h6 className={classesTable.listDescription}>
                            {c.cartChild.map((f) =>
                              f.title === "Plating Gold Plated"
                                ? f.title.slice(8)
                                : ""
                            )}{" "}
                            {c.parentTitle} {c.rawTitle} <br />
                            {c.categoryTitle} with {c.packingType}
                            <br />
                            {(c.readyGram * c.setsPcs).toFixed(4)} Avg Gram of {c.setsDesc}
                            <br />
                            Sets Price :{" "}
                            {c.gstCash === false
                              ? (c.cashPrice / c.box).toFixed(2)
                              : (c.taxInclude / c.box).toFixed(2)}
                            /- {c.gstCash === false ? "Cash" : "IncTax"}
                            <br />
                            Metal Rate : ₹ {c.rawPrice + c.rawDifferent}/-
                            Advance : ₹
                            {Math.round(
                              c.metalGram *
                              c.setsPcs *
                              c.box *
                              c.sizeTotal *
                              (c.rawPrice + c.rawDifferent)
                            )}
                          </h6>
                          <GridContainer className={classesTable.sizePadding}>
                            {c.size1x8 != 0 ? (
                              <span
                                className={
                                  classes.textCenter +
                                  " " +
                                  classes.sizeSpan +
                                  " " +
                                  classes.listDescriptionMM
                                }
                              >
                                {c.size1x8 == null
                                  ? ""
                                  : c.size1x8 == 0
                                    ? ""
                                    : "1x8"}
                                <br />
                                {c.size1x8 == null
                                  ? ""
                                  : c.size1x8 == 0
                                    ? ""
                                    : c.size1x8}
                              </span>
                            ) : (
                              ""
                            )}
                            {c.size1x10 != 0 ? (
                              <span
                                className={
                                  classes.textCenter +
                                  " " +
                                  classes.sizeSpan +
                                  " " +
                                  classes.listDescriptionMM
                                }
                              >
                                {c.size1x10 == null
                                  ? ""
                                  : c.size1x10 == 0
                                    ? ""
                                    : "1x10"}
                                <br />
                                {c.size1x10 == null
                                  ? ""
                                  : c.size1x10 == 0
                                    ? ""
                                    : c.size1x10}
                              </span>
                            ) : (
                              ""
                            )}
                            {c.size1x12 != 0 ? (
                              <span
                                className={
                                  classes.textCenter +
                                  " " +
                                  classes.sizeSpan +
                                  " " +
                                  classes.listDescriptionMM
                                }
                              >
                                {c.size1x12 == null
                                  ? ""
                                  : c.size1x12 == 0
                                    ? ""
                                    : "1x12"}
                                <br />
                                {c.size1x12 == null
                                  ? ""
                                  : c.size1x12 == 0
                                    ? ""
                                    : c.size1x12}
                              </span>
                            ) : (
                              ""
                            )}
                            {c.size1x14 != 0 ? (
                              <span
                                className={
                                  classes.textCenter +
                                  " " +
                                  classes.sizeSpan +
                                  " " +
                                  classes.listDescriptionMM
                                }
                              >
                                {c.size1x14 == null
                                  ? ""
                                  : c.size1x14 == 0
                                    ? ""
                                    : "1x14"}
                                <br />
                                {c.size1x14 == null
                                  ? ""
                                  : c.size1x14 == 0
                                    ? ""
                                    : c.size1x14}
                              </span>
                            ) : (
                              ""
                            )}
                            {c.size2x0 != 0 ? (
                              <span
                                className={
                                  classes.textCenter +
                                  " " +
                                  classes.sizeSpan +
                                  " " +
                                  classes.listDescriptionMM
                                }
                              >
                                {c.size2x0 == null
                                  ? ""
                                  : c.size2x0 == 0
                                    ? ""
                                    : "2x0"}
                                <br />
                                {c.size2x0 == null
                                  ? ""
                                  : c.size2x0 == 0
                                    ? ""
                                    : c.size2x0}
                              </span>
                            ) : (
                              ""
                            )}
                            {c.size2x2 != 0 ? (
                              <span
                                className={
                                  classes.textCenter +
                                  " " +
                                  classes.sizeSpan +
                                  " " +
                                  classes.listDescriptionMM
                                }
                              >
                                {c.size2x2 == null
                                  ? ""
                                  : c.size2x2 == 0
                                    ? ""
                                    : "2x2"}
                                <br />
                                {c.size2x2 == null
                                  ? ""
                                  : c.size2x2 == 0
                                    ? ""
                                    : c.size2x2}
                              </span>
                            ) : (
                              ""
                            )}
                            {c.size2x4 != 0 ? (
                              <span
                                className={
                                  classes.textCenter +
                                  " " +
                                  classes.sizeSpan +
                                  " " +
                                  classes.listDescriptionMM
                                }
                              >
                                {c.size2x4 == null
                                  ? ""
                                  : c.size2x4 == 0
                                    ? ""
                                    : "2x4"}
                                <br />
                                {c.size2x4 == null
                                  ? ""
                                  : c.size2x4 == 0
                                    ? ""
                                    : c.size2x4}
                              </span>
                            ) : (
                              ""
                            )}
                            {c.size2x6 != 0 ? (
                              <span
                                className={
                                  classes.textCenter +
                                  " " +
                                  classes.sizeSpan +
                                  " " +
                                  classes.listDescriptionMM
                                }
                              >
                                {c.size2x6 == null
                                  ? ""
                                  : c.size2x6 == 0
                                    ? ""
                                    : "2x6"}
                                <br />
                                {c.size2x6 == null
                                  ? ""
                                  : c.size2x6 == 0
                                    ? ""
                                    : c.size2x6}
                              </span>
                            ) : (
                              ""
                            )}
                            {c.size2x8 != 0 ? (
                              <span
                                className={
                                  classes.textCenter +
                                  " " +
                                  classes.sizeSpan +
                                  " " +
                                  classes.listDescriptionMM
                                }
                              >
                                {c.size2x8 == null
                                  ? ""
                                  : c.size2x8 == 0
                                    ? ""
                                    : "2x8"}
                                <br />
                                {c.size2x8 == null
                                  ? ""
                                  : c.size2x8 == 0
                                    ? ""
                                    : c.size2x8}
                              </span>
                            ) : (
                              ""
                            )}
                            {c.size2x10 != 0 ? (
                              <span
                                className={
                                  classes.textCenter +
                                  " " +
                                  classes.sizeSpan +
                                  " " +
                                  classes.listDescriptionMM
                                }
                              >
                                {c.size2x10 == null
                                  ? ""
                                  : c.size2x10 == 0
                                    ? ""
                                    : "2x10"}
                                <br />
                                {c.size2x10 == null
                                  ? ""
                                  : c.size2x10 == 0
                                    ? ""
                                    : c.size2x10}
                              </span>
                            ) : (
                              ""
                            )}
                            {c.size2x12 != 0 ? (
                              <span
                                className={
                                  classes.textCenter +
                                  " " +
                                  classes.sizeSpan +
                                  " " +
                                  classes.listDescriptionMM
                                }
                              >
                                {c.size2x12 == null
                                  ? ""
                                  : c.size2x12 == 0
                                    ? ""
                                    : "2x12"}
                                <br />
                                {c.size2x12 == null
                                  ? ""
                                  : c.size2x12 == 0
                                    ? ""
                                    : c.size2x12}
                              </span>
                            ) : (
                              ""
                            )}
                            {c.size2x14 != 0 ? (
                              <span
                                className={
                                  classes.textCenter +
                                  " " +
                                  classes.sizeSpan +
                                  " " +
                                  classes.listDescriptionMM
                                }
                              >
                                {c.size2x14 == null
                                  ? ""
                                  : c.size2x14 == 0
                                    ? ""
                                    : "2x14"}
                                <br />
                                {c.size2x14 == null
                                  ? ""
                                  : c.size2x14 == 0
                                    ? ""
                                    : c.size2x14}
                              </span>
                            ) : (
                              ""
                            )}
                            {c.size3x0 != 0 ? (
                              <span
                                className={
                                  classes.textCenter +
                                  " " +
                                  classes.sizeSpan +
                                  " " +
                                  classes.listDescriptionMM
                                }
                              >
                                {c.size3x0 == null
                                  ? ""
                                  : c.size3x0 == 0
                                    ? ""
                                    : "3x0"}
                                <br />
                                {c.size3x0 == null
                                  ? ""
                                  : c.size3x0 == 0
                                    ? ""
                                    : c.size3x0}
                              </span>
                            ) : (
                              ""
                            )}
                          </GridContainer>
                          <GridContainer className={classesTable.sizePadding}>
                            {c.size1x9 != 0 ? (
                              <span
                                className={
                                  classes.textCenter +
                                  " " +
                                  classes.sizeSpan +
                                  " " +
                                  classes.listDescriptionMM
                                }
                              >
                                {c.size1x9 == null
                                  ? ""
                                  : c.size1x9 == 0
                                    ? ""
                                    : "1x9"}
                                <br />
                                {c.size1x9 == null
                                  ? ""
                                  : c.size1x9 == 0
                                    ? ""
                                    : c.size1x9}
                              </span>
                            ) : (
                              ""
                            )}
                            {c.size1x11 != 0 ? (
                              <span
                                className={
                                  classes.textCenter +
                                  " " +
                                  classes.sizeSpan +
                                  " " +
                                  classes.listDescriptionMM
                                }
                              >
                                {c.size1x11 == null
                                  ? ""
                                  : c.size1x11 == 0
                                    ? ""
                                    : "1x11"}
                                <br />
                                {c.size1x11 == null
                                  ? ""
                                  : c.size1x11 == 0
                                    ? ""
                                    : c.size1x11}
                              </span>
                            ) : (
                              ""
                            )}
                            {c.size1x13 != 0 ? (
                              <span
                                className={
                                  classes.textCenter +
                                  " " +
                                  classes.sizeSpan +
                                  " " +
                                  classes.listDescriptionMM
                                }
                              >
                                {c.size1x13 == null
                                  ? ""
                                  : c.size1x13 == 0
                                    ? ""
                                    : "1x13"}
                                <br />
                                {c.size1x13 == null
                                  ? ""
                                  : c.size1x13 == 0
                                    ? ""
                                    : c.size1x13}
                              </span>
                            ) : (
                              ""
                            )}
                            {c.size1x15 != 0 ? (
                              <span
                                className={
                                  classes.textCenter +
                                  " " +
                                  classes.sizeSpan +
                                  " " +
                                  classes.listDescriptionMM
                                }
                              >
                                {c.size1x15 == null
                                  ? ""
                                  : c.size1x15 == 0
                                    ? ""
                                    : "1x15"}
                                <br />
                                {c.size1x15 == null
                                  ? ""
                                  : c.size1x15 == 0
                                    ? ""
                                    : c.size1x15}
                              </span>
                            ) : (
                              ""
                            )}
                            {c.size2x1 != 0 ? (
                              <span
                                className={
                                  classes.textCenter +
                                  " " +
                                  classes.sizeSpan +
                                  " " +
                                  classes.listDescriptionMM
                                }
                              >
                                {c.size2x1 == null
                                  ? ""
                                  : c.size2x1 == 0
                                    ? ""
                                    : "2x1"}
                                <br />
                                {c.size2x1 == null
                                  ? ""
                                  : c.size2x1 == 0
                                    ? ""
                                    : c.size2x1}
                              </span>
                            ) : (
                              ""
                            )}
                            {c.size2x3 != 0 ? (
                              <span
                                className={
                                  classes.textCenter +
                                  " " +
                                  classes.sizeSpan +
                                  " " +
                                  classes.listDescriptionMM
                                }
                              >
                                {c.size2x3 == null
                                  ? ""
                                  : c.size2x3 == 0
                                    ? ""
                                    : "2x3"}
                                <br />
                                {c.size2x3 == null
                                  ? ""
                                  : c.size2x3 == 0
                                    ? ""
                                    : c.size2x3}
                              </span>
                            ) : (
                              ""
                            )}
                            {c.size2x5 != 0 ? (
                              <span
                                className={
                                  classes.textCenter +
                                  " " +
                                  classes.sizeSpan +
                                  " " +
                                  classes.listDescriptionMM
                                }
                              >
                                {c.size2x5 == null
                                  ? ""
                                  : c.size2x5 == 0
                                    ? ""
                                    : "2x5"}
                                <br />
                                {c.size2x5 == null
                                  ? ""
                                  : c.size2x5 == 0
                                    ? ""
                                    : c.size2x5}
                              </span>
                            ) : (
                              ""
                            )}
                            {c.size2x7 != 0 ? (
                              <span
                                className={
                                  classes.textCenter +
                                  " " +
                                  classes.sizeSpan +
                                  " " +
                                  classes.listDescriptionMM
                                }
                              >
                                {c.size2x7 == null
                                  ? ""
                                  : c.size2x7 == 0
                                    ? ""
                                    : "2x7"}
                                <br />
                                {c.size2x7 == null
                                  ? ""
                                  : c.size2x7 == 0
                                    ? ""
                                    : c.size2x7}
                              </span>
                            ) : (
                              ""
                            )}
                            {c.size2x9 != 0 ? (
                              <span
                                className={
                                  classes.textCenter +
                                  " " +
                                  classes.sizeSpan +
                                  " " +
                                  classes.listDescriptionMM
                                }
                              >
                                {c.size2x9 == null
                                  ? ""
                                  : c.size2x9 == 0
                                    ? ""
                                    : "2x9"}
                                <br />
                                {c.size2x9 == null
                                  ? ""
                                  : c.size2x9 == 0
                                    ? ""
                                    : c.size2x9}
                              </span>
                            ) : (
                              ""
                            )}
                            {c.size2x11 != 0 ? (
                              <span
                                className={
                                  classes.textCenter +
                                  " " +
                                  classes.sizeSpan +
                                  " " +
                                  classes.listDescriptionMM
                                }
                              >
                                {c.size2x11 == null
                                  ? ""
                                  : c.size2x11 == 0
                                    ? ""
                                    : "2x11"}
                                <br />
                                {c.size2x11 == null
                                  ? ""
                                  : c.size2x11 == 0
                                    ? ""
                                    : c.size2x11}
                              </span>
                            ) : (
                              ""
                            )}
                            {c.size2x13 != 0 ? (
                              <span
                                className={
                                  classes.textCenter +
                                  " " +
                                  classes.sizeSpan +
                                  " " +
                                  classes.listDescriptionMM
                                }
                              >
                                {c.size2x13 == null
                                  ? ""
                                  : c.size2x13 == 0
                                    ? ""
                                    : "2x13"}
                                <br />
                                {c.size2x13 == null
                                  ? ""
                                  : c.size2x13 == 0
                                    ? ""
                                    : c.size2x13}
                              </span>
                            ) : (
                              ""
                            )}
                            {c.size2x15 != 0 ? (
                              <span
                                className={
                                  classes.textCenter +
                                  " " +
                                  classes.sizeSpan +
                                  " " +
                                  classes.listDescriptionMM
                                }
                              >
                                {c.size2x15 == null
                                  ? ""
                                  : c.size2x15 == 0
                                    ? ""
                                    : "2x15"}
                                <br />
                                {c.size2x15 == null
                                  ? ""
                                  : c.size2x15 == 0
                                    ? ""
                                    : c.size2x15}
                              </span>
                            ) : (
                              ""
                            )}
                            {c.size3x1 != 0 ? (
                              <span
                                className={
                                  classes.textCenter +
                                  " " +
                                  classes.sizeSpan +
                                  " " +
                                  classes.listDescriptionMM
                                }
                              >
                                {c.size3x1 == null
                                  ? ""
                                  : c.size3x1 == 0
                                    ? ""
                                    : "3x1"}
                                <br />
                                {c.size3x1 == null
                                  ? ""
                                  : c.size3x1 == 0
                                    ? ""
                                    : c.size3x1}
                              </span>
                            ) : (
                              ""
                            )}
                          </GridContainer>
                          {/* <span className={classesTable.listDescription}>{c && c.name ? c.name + ", " : ""} {c && c.mycomment ? c.mycomment : ""}</span> */}
                        </span>,
                        <span
                          className={
                            classesTable.headRight +
                            " " +
                            classesTable.listNumber
                          }
                          key={c.id}
                        >
                          {c.cartQuantity}
                        </span>,
                        <span
                          className={
                            classesTable.headRight +
                            " " +
                            classesTable.listNumber
                          }
                          key={c.id}
                        >
                          {c.sizeTotal}
                        </span>,
                        <span
                          className={
                            classesTable.headRight +
                            " " +
                            classesTable.listNumber
                          }
                          key={c.id}
                        >
                          ₹
                          {c.gstCash === true
                            ? c.taxInclude.toFixed(2)
                            : c.cashPrice.toFixed(2)}
                        </span>,
                        <span
                          className={
                            classesTable.headRight +
                            " " +
                            classesTable.listNumber
                          }
                          key={c.id}
                        >
                          ₹{roundUp(c.amount, 2)}
                        </span>,
                        <Tooltip
                          id="close1"
                          title="Cart Remove"
                          placement="left"
                          classes={{ tooltip: classeCart.tooltip }}
                          key={c.id}
                        >
                          <Button
                            link
                            className={classeCart.actionButton}
                            onClick={() => {
                              handleitemRemove(c.id);
                              setCartId(c);
                            }}
                          >
                            <Close style={{ color: "red" }} />
                          </Button>
                        </Tooltip>,
                      ]),
                      [
                        "",
                        <span className={classesTable.listNumber} key={1}>
                          Cartoon Charges
                          <br />
                          Grand Total
                        </span>,
                        <span className={classesTable.listNumber} key={2}>
                          <br />
                          Advance - ₹{" "}
                          {Math.round(
                            addCart.reduce(
                              (a, b) =>
                                a +
                                b.metalGram *
                                b.setsPcs *
                                b.box *
                                b.sizeTotal *
                                (b.rawPrice + b.rawDifferent),
                              0
                            )
                          ) + "/-"}
                        </span>,
                        <span key={3}>
                          <br />
                          <span className={classesTable.headRight}>
                            Carton-
                            {addCart.reduce((a, b) => a + b.cartQuantity, 0)}
                          </span>
                        </span>,
                        <span>
                          <br />
                          <span
                            className={
                              classesTable.headRight +
                              " " +
                              classesTable.listNumber
                            }
                          >
                            Unit-
                            {addCart &&
                              addCart.reduce((a, b) => a + b.sizeTotal, 0)}
                          </span>
                        </span>,
                        "",
                        <span key={4}>
                          <span
                            className={
                              classesTable.headRight +
                              " " +
                              classesTable.listNumber
                            }
                          >
                            ₹
                            {roundUp(addCart.reduce(
                              (a, b) => a + b.cartPackCharge * b.cartQuantity,
                              0
                            ), 2) + "/-"}
                          </span>
                          <br />
                          <span
                            className={
                              classesTable.headRight +
                              " " +
                              classesTable.listNumber
                            }
                          >
                            ₹
                            {roundUp(
                              addCart.reduce(
                                (a, b) =>
                                  a +
                                  b.amount +
                                  b.cartPackCharge * b.cartQuantity,
                                0
                              ), 2
                            ) + "/-"}
                          </span>
                        </span>,
                        "",
                      ],
                    ]}
                  />
                  <hr />
                  {allSameGstCash === true ?
                    <Button
                      style={{
                        float: "right",
                        marginTop: "15px",
                        marginBottom: "15px",
                      }}
                      color="rose"
                      round
                      href="/cart-shipping-address"
                    >
                      Proceed Order
                    </Button> :
                    <Button
                      style={{
                        float: "right",
                        marginTop: "15px",
                        marginBottom: "15px",
                      }}
                      color="default"
                      round
                      onClick={() => {
                        setSubmitteds(true);
                        alertMsgOps("Either GST or Cash, not both.");
                      }}
                    >
                      Proceed Order
                    </Button>}
                </CardBody>
              </Card>
            </div>
          </div>
          <Footer />
        </>
      ) : (
        ""
      )}
    </div>
  );
}
